import React, { useEffect, useState, useCallback } from "react";
import { debounce } from "lodash-es";
import TextField from "@material-ui/core/TextField";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { TreeView } from '@material-ui/lab';

import { TreeLeaf } from './TreeLeaf';

import cn from "./SalesAgenciesTree.module.scss";

function filterTree(tree, search) {
  const matchedItemIds = [];
  const expandedItemIds = [];

  const getNodes = (result, object) => {
    const searchParts = [
      object.user.first_name || '',
      object.user.last_name || '',
      object.user.apasi_user_asafid || '',
      `${object.user.first_name} ${object.user.last_name}`
    ];

    if (searchParts.some((part) => part.toLowerCase().startsWith(search.toLowerCase()))) {
      result.push(object);
      matchedItemIds.push(object.user.ID.toString());
      expandedItemIds.push(object.user.ID.toString());
      return result;
    }
    if (Array.isArray(object.children)) {
      const children = object.children.reduce(getNodes, []);
      if (children.length) {
        expandedItemIds.push(object.user.ID.toString());
        result.push({ ...object, children })
      }
    }
    return result;
  };

  const [filteredTree] = [tree].reduce(getNodes, []);

  return {
    tree: filteredTree,
    matchedItemIds,
    expandedItemIds,
  };
}

export function SalesAgenciesTree({ agencyTree }) {
  const [filteredTreeState, setFilteredTreeState] = useState({
    tree: agencyTree,
    matchedItemIds: [],
    expandedItemIds: [],
  })
  const [search, setSearch] = useState('');
  const haveChildren = agencyTree && agencyTree.children && agencyTree.children.length;

  useEffect(() => {
    if (search && agencyTree) {
      setFilteredTreeState(filterTree(agencyTree, search))
    } else {
      setFilteredTreeState({
        tree: agencyTree,
        matchedItemIds: [],
        expandedItemIds: [],
      });
    }
  }, [search, agencyTree])

  const handleChange = useCallback(
    debounce((value) => setSearch(value), 800),
    [setSearch],
  );

  return haveChildren ? (
    <div className={cn.agenciesTree}>
      <div className={cn.header}>Your agency network:</div>
      <TextField
        onChange={(event) => handleChange(event.target.value)}
        variant="outlined"
        label="Search"
        fullWidth
        className={cn.searchInput}
      />
      {search && !filteredTreeState.tree ? (
        <div className={cn.notFoundMessage}>No agencies found for "{search}"</div>
      ) : (
        filteredTreeState.tree ? (
          <TreeView
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
            expanded={filteredTreeState.expandedItemIds}
            onNodeToggle={(event, nodeIds) => setFilteredTreeState({...filteredTreeState, expandedItemIds: nodeIds})}
          >
            <TreeLeaf
              matchedItemIds={filteredTreeState.matchedItemIds}
              agency={filteredTreeState.tree}
              nodeId={filteredTreeState.tree.user.ID.toString()}
            />
          </TreeView>
        ) : ''
      )}
    </div>
  ) : (
    <div className={cn.header}>You have no agencies in your network</div>
  )
}
